import React, { useMemo } from 'react';
import GeneralLayout from 'src/layouts/general';
import ProductTopIntroduction from 'src/components/POSWebsite/ProductTopIntroduction';
import ScheduleYourFreeDemo from 'src/components/POSWebsite/ScheduleYourFreeDemo';
import WhyChooseChowbus from 'src/components/POSWebsite/WhyChooseChowbus';
import EverythingNeedInOnePOSSystem from 'src/components/POSWebsite/EverythingNeedInOnePOSSystem';
import UsingServiceAdvantage from 'src/components/POSWebsite/UsingServiceAdvantage';
import FrequentlyAskedQuestions from 'src/components/POSWebsite/FrequentlyAskedQuestions';
import useSEOMeta from 'src/hooks/useSEOMetaHook';
import useLocale from 'src/hooks/useLocale';

const ServiceTypePage = ({
  pageId,
  pageContent,
  featureCardStyle = 'border_card',
  whyChowbusShowModel = 'default',
  customerCaseKeys,
  productsNeedInOnePOSSystem = [],
}) => {
  const locale = useLocale();
  const { keywords, pageTitle, metaDescription } = useSEOMeta({ pageId: pageId });
  const {
    everythingNeedInOnePOSSystem,
    usingServiceAdvantage,
    topIntroductionContent,
    frequentlyAskedQuestionsContent,
  } = useMemo(() => {
    let everythingNeedInOnePOSSystem = pageContent.everythingNeedInOnePOSSystem[locale];
    let usingServiceAdvantage = pageContent.usingServiceAdvantage[locale];
    let topIntroductionContent = pageContent.topSection[locale];
    let frequentlyAskedQuestionsContent = pageContent.frequentlyAskedQuestions[locale];
    return {
      everythingNeedInOnePOSSystem,
      usingServiceAdvantage,
      topIntroductionContent,
      frequentlyAskedQuestionsContent,
    };
  }, [locale, pageContent]);

  return (
    <GeneralLayout
      pageId={`pos-web-site-home-page-enh ${pageId}`}
      keywords={keywords}
      pageTitle={pageTitle}
      metaDescription={metaDescription}
    >
      <ProductTopIntroduction
        forBusiessType={true}
        title={topIntroductionContent.title}
        description={topIntroductionContent.description}
        poster={`${topIntroductionContent.poster || ''}`}
        videoId={topIntroductionContent.youtubeVideoId || ''}
      />

      {customerCaseKeys && (
        <WhyChooseChowbus
          showModel={whyChowbusShowModel || 'default'}
          forServiceType={true}
          customerCaseKeys={customerCaseKeys}
        />
      )}

      <UsingServiceAdvantage content={usingServiceAdvantage} />
      <EverythingNeedInOnePOSSystem
        productsNeed={productsNeedInOnePOSSystem}
        title={everythingNeedInOnePOSSystem.title}
      />

      <FrequentlyAskedQuestions content={frequentlyAskedQuestionsContent} />

      <ScheduleYourFreeDemo />
    </GeneralLayout>
  );
};

// const FrequentlyAskedQuestions = () => {
//   return <div>FrequentlyAskedQuestions</div>;
// };

export default ServiceTypePage;
